import { render, staticRenderFns } from "./globalPayForConfig.vue?vue&type=template&id=b70d283c&scoped=true"
import script from "./globalPayForConfig.vue?vue&type=script&lang=js"
export * from "./globalPayForConfig.vue?vue&type=script&lang=js"
import style0 from "./globalPayForConfig.vue?vue&type=style&index=0&id=b70d283c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b70d283c",
  null
  
)

export default component.exports